export default __webpack_public_path__ + "static/media/undraw_bug_fixing.cd8b68f5.svg";